import React from 'react'
import { SCHOOL_AGE_FLAGS } from '../../app/constants/flags'
import { getLang } from '../../app/selectors/lang'
import SedaFlagGroup from './SedaFlagGroup'

/**
 * Displays a button group of age group filters that can be
 * toggled on and off.
 */
const SedaAgeGroup = ({ region, ...props }) => {
  // age group flags
  const flags = SCHOOL_AGE_FLAGS
  // are groups are only available for schools
  const isDisabled = region !== 'schools'
  // text when disabled: These filters are only available in {{regions}} view.
  const tooltipText =
    isDisabled &&
    getLang('TOOLTIP_HINT_REGION_FILTER', {
      regions: 'schools'
    })

  return (
    <SedaFlagGroup
      tooltip={tooltipText}
      disabled={isDisabled}
      flags={flags}
      {...props}
    />
  )
}

export default SedaAgeGroup
